import { useRef, useEffect } from 'preact/hooks';

interface InputAreaProps {
  onSend: (text: string) => void;
  onInteraction?: () => void;
  disabled: boolean;
}

export function InputArea({ onSend, onInteraction, disabled }: InputAreaProps): preact.JSX.Element {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const handleSubmit = (e?: Event): void => {
    e?.preventDefault();
    const val = inputRef.current?.value?.trim();
    if (val) {
      onSend(val);
      if (inputRef.current) inputRef.current.value = '';
    }
  };

  const handleKeyDown = (e: KeyboardEvent): void => {
    onInteraction?.();
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit();
    }
  };

  const handleInput = (): void => {
    onInteraction?.();
  };

  return (
    <>
      <div class="yd-input-area">
        <input
          ref={inputRef}
          class="yd-input"
          type="text"
          placeholder="Type a message..."
          onKeyDown={handleKeyDown}
          onInput={handleInput}
          disabled={disabled}
        />
        <button
          class="yd-send-btn"
          onClick={() => handleSubmit()}
          disabled={disabled}
          aria-label="Send message"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
          </svg>
        </button>
      </div>
    </>
  );
}
